/** Static filming display: no playlist, borders, labels, animation or timers. */
export function DroneLogo({ landscape = false }: { landscape?: boolean }) {
  return <main className={`drone-logo-page${landscape ? ' drone-logo-page--landscape' : ''}`} aria-label="Elevation VA-logo voor droneopname"><img src="/branding/elevation-va-white.png" alt="Elevation VA" draggable={false} /></main>;
}
